
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 131 131"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Livello 2"}},[_c('g',{attrs:{"data-name":"Livello 1"}},[_c('path',{attrs:{"data-name":"Search Icon","d":"M83 96a48 48 0 1148-48 48.05 48.05 0 01-48 48zm0-94a46 46 0 1046 46A46.06 46.06 0 0083 2zM1.71 130.71l36-36a1 1 0 10-1.42-1.42l-36 36a1 1 0 000 1.42 1 1 0 001.42 0z"}})])])])
          )
        }
      }
    